import React from 'react';
import { useTranslation } from 'react-i18next';
import './AsrModeInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';
import { CaptionSourceEnum } from '../../../types/enums/CaptionSourceEnum';
import { CaptionModeEnum } from '../../../types/enums/CaptionModeEnum';
import Help from '../../Help/Help';

const AsrModeInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        captionSource: value,
        captionMode:
          project.encoder.captionMode === CaptionModeEnum.None
            ? CaptionModeEnum.Open
            : project.encoder.captionMode || CaptionModeEnum.Open,
      });
    } else {
      updateEncoder(project.encoder, {
        overlayAutoHideTimeout: value,
        captionMode:
          project.encoder.captionMode === CaptionModeEnum.None
            ? CaptionModeEnum.Open
            : project.encoder.captionMode || CaptionModeEnum.Open,
      });
    }
  };

  return (
    <div className="asr-mode-input">
      <div className="input-title">
        {t('producer.inputs.asr-mode.title')}
        <Help
          title="AI Mode"
          text="Turn on for AI captions and off for human captioning. If you would like to switch between AI and human captioning, this button allows you to do that."
        />
      </div>
      <ToggleButton
        leftText={t('producer.common.on')}
        leftValue={CaptionSourceEnum.ASR}
        leftButtonClassName={`asr-mode-button ${
          project.encoder?.captionSource === CaptionSourceEnum.ASR
            ? 'control-panel-button-selected-button'
            : null
        }`}
        leftContentClassName="asr-mode-text"
        rightText={t('producer.common.off')}
        rightValue={CaptionSourceEnum.StreamText}
        rightButtonClassName={`asr-mode-button ${
          project.encoder?.captionSource !== CaptionSourceEnum.ASR
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightContentClassName="asr-mode-text"
        footerText={t(`producer.inputs.asr-mode.footer`)}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.common.on')}
        rightAccessibilityName={t('producer.common.off')}
      />
    </div>
  );
};

export default React.memo(AsrModeInput);
